export const newsnevents=[
  {
    "displayText": "ADMISSION STARTING NEWS",
    "filename": "./assets/documentation/newsNEvents/ADMISSION STARTING NEWS.pdf",
    "link": ""
  },
  {
    "displayText": "RESULT NEWS 2024-25 (2)",
    "filename": "./assets/documentation/newsNEvents/RESULT NEWS 2024-25 (2).pdf",
    "link": ""
  },
  {
    "displayText": "RESULT NEWS 2024-25 (3)",
    "filename": "./assets/documentation/newsNEvents/RESULT NEWS 2024-25 (3).pdf",
    "link": ""
  },
  {
    "displayText": "RESULT NEWS 2024-25 (4)",
    "filename": "./assets/documentation/newsNEvents/RESULT NEWS 2024-25 (4).pdf",
    "link": ""
  },
  {
    "displayText": "RESULT NEWS 2024-25",
    "filename": "./assets/documentation/newsNEvents/RESULT NEWS 2024-25.pdf",
    "link": ""
  },
  {
    "displayText": "TREE PLANTATION NEWS (2)",
    "filename": "./assets/documentation/newsNEvents/TREE PLANTATION NEWS (2).pdf",
    "link": ""
  },
  {
    "displayText": "TREE PLANTATION NEWS (3)",
    "filename": "./assets/documentation/newsNEvents/TREE PLANTATION NEWS (3).pdf",
    "link": ""
  },
  {
    "displayText": "TREE PLANTATION NEWS (4)",
    "filename": "./assets/documentation/newsNEvents/TREE PLANTATION NEWS (4).pdf",
    "link": ""
  },
  {
    "displayText": "TREE PLANTATION NEWS",
    "filename": "./assets/documentation/newsNEvents/TREE PLANTATION NEWS.pdf",
    "link": ""
  }
]